import Select, { StylesConfig, GroupBase, OptionProps, MultiValueRemoveProps, MultiValueGenericProps } from "react-select";
import Str from "../../helpers/Str";
import { IInputSelect } from "../../types";

// Defina o tipo para suas opções
interface SelectOption {
    value: string | number;
    label: string;
}

export default function InputSelect({
                                        selected,
                                        className,
                                        margintopClassName,
                                        label,
                                        classNameContainer,
                                        loading,
                                        options,
                                        onChangeSelect,
                                        placeholder,
                                        isMulti,
                                        isOptionDisabled,
                                        isDisabled,
                                        key,
                                        value,
                                        setValue,
                                        disabled,
                                        error,
                                        required,
                                        isClearable
                                    }: IInputSelect) {

    const inputSelectStyle = () => ({
        paddingBottom: '5px',
        paddingTop: '6px',
    });

    const backgroundDifferentOptions = (isSelected: boolean, isFocused: boolean) => {
        if (isSelected && isFocused) return "#E0A422";
        if (!isSelected && isFocused) return "#E0A422";
        if (isSelected && !isFocused) return "#13131a";
        if (!isSelected && !isFocused) return "#13131a";
        return "#13131a"; // fallback
    };

    // Defina os tipos para os estilos
    const customStyles: StylesConfig<SelectOption, boolean> = {
        option: (provided, state) => ({
            ...provided,
            color: state.isFocused ? "black" : "white",
            backgroundColor: backgroundDifferentOptions(state.isSelected, state.isFocused),
            borderColor: "#e0a422"
        }),
        input: (provided) => ({
            ...provided,
            ...inputSelectStyle()
        }),
        control: (provided) => ({
            ...provided,
            borderRadius: '0.375rem',
            backgroundColor: '#13131a'
        }),
        menuList: (provided) => ({
            ...provided,
            backgroundColor: '#13131a'
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#939396'
        }),
        multiValue: (provided) => ({
            ...provided,
            color: 'white',
            backgroundColor: '#e0a422'
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: 'white',
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            ':hover': {
                backgroundColor: '#e0a422',
                color: 'white',
            },
        }),
    };

    return (
        <div key={key} className={className ?? classNameContainer}>
            {label && (
                <label>
                    {label}
                    {required && <span className='text-red-600'> *</span>}
                </label>
            )}

            <Select<SelectOption, boolean>
                required={required}
                closeMenuOnSelect={false}
                blurInputOnSelect={false}
                menuPlacement={'auto'}
                isClearable={isClearable}
                isLoading={loading}
                placeholder={placeholder ?? ''}
                value={
                    value
                        ? (isMulti
                            ? options?.filter((opt) => value.includes(opt.value))
                            : options?.filter((opt) => opt.value === value))
                        : (options?.filter((opt) => opt.value === selected) ?? [])
                }
                className={Str.tw(
                    margintopClassName
                        ? margintopClassName
                        : (label ? 'mt-[0px]' : 'lg:mt-[1.5rem] sm:mt-[1rem] min-[320px]:mt-[5px] text-[#fff]'),
                )}
                styles={customStyles}
                options={options}
                onChange={(e: any) => {
                    if (setValue) {
                        const newValue = isMulti
                            ? Array.isArray(e)
                                ? e.map(item => item?.value ?? null)
                                : []
                            : e?.value ?? null;
                        setValue(newValue);
                    } else if (onChangeSelect) {
                        onChangeSelect(e);
                    }
                }}
                isMulti={isMulti}
                isOptionDisabled={isOptionDisabled}
                isDisabled={isDisabled ?? disabled}
            />
            {!!error?.length && <span className="text-red-600 ">{error}</span>}
        </div>
    );
}
